(function() {
  var WIDGET_SELECTOR = '[data-plan-cta-widget]';
  var widgets = [];
  var variantSubscription = null;

  function parseJSON(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, locale, currency) {
    var amount = Number(cents || 0) / 100;
    if (!Number.isFinite(amount)) amount = 0;

    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function getVariantById(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    var target = String(variantId || '');

    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      if (String(variant.id) === target) return variant;
    }

    return product.variants[0] || null;
  }

  function getSellingPlanAllocation(variant, planId) {
    if (!variant || !planId || !Array.isArray(variant.selling_plan_allocations)) return null;
    var target = String(planId);

    for (var i = 0; i < variant.selling_plan_allocations.length; i += 1) {
      var allocation = variant.selling_plan_allocations[i];
      if (!allocation) continue;
      var allocationId = String(allocation.selling_plan_id || allocation.id || '');
      if (allocationId === target) return allocation;
    }

    return null;
  }

  function createBubblingEvent(name) {
    try {
      return new Event(name, { bubbles: true });
    } catch (error) {
      var legacy = document.createEvent('Event');
      legacy.initEvent(name, true, false);
      return legacy;
    }
  }

  function PlanCtaWidget(root) {
    this.root = root;
    this.sectionId = String(root.getAttribute('data-section-id') || '');
    this.mainProductId = root.getAttribute('data-main-product-id') || '';
    this.formId = root.getAttribute('data-form-id') || '';
    this.locale = root.getAttribute('data-locale') || undefined;
    this.currency = root.getAttribute('data-currency') || 'USD';

    this.showCompare = root.getAttribute('data-show-compare') === 'true';
    this.showSavings = root.getAttribute('data-show-savings') === 'true';
    this.savingsMode = root.getAttribute('data-savings-mode') || 'amount';
    this.savePrefix = root.getAttribute('data-save-prefix') || 'Save';
    this.priceSuffix = root.getAttribute('data-price-suffix') || '';
    this.showCurrency = root.getAttribute('data-show-currency') === 'true';
    this.requirePlan = root.getAttribute('data-require-plan') === 'true';

    this.buttonLabelDefault = root.getAttribute('data-button-label-default') || 'Add to cart';
    this.buttonLabelRequirePlan = root.getAttribute('data-button-label-require-plan') || this.buttonLabelDefault;
    this.buttonLabelSoldout = root.getAttribute('data-button-label-soldout') || 'Sold out';

    this.selectedVariantId = String(root.getAttribute('data-selected-variant-id') || '');

    this.product = parseJSON(root.querySelector('[data-plan-cta-product]'));

    this.compareNode = root.querySelector('[data-plan-cta-compare]');
    this.priceNode = root.querySelector('[data-plan-cta-price]');
    this.currencyNode = root.querySelector('[data-plan-cta-currency]');
    this.saveNode = root.querySelector('[data-plan-cta-save]');
    this.buttonNode = root.querySelector('[data-plan-cta-button]');
    this.buttonLabelNode = root.querySelector('[data-plan-cta-button-label]');
    this.variantInput = root.querySelector('[data-plan-cta-variant-input]');
    this.planInput = root.querySelector('[data-plan-cta-plan-input]');

    this.scopeNode = this.mainProductId ? document.getElementById(this.mainProductId) : document;
    this.mainVariantInput = document.querySelector('#product-form-' + this.sectionId + ' input[name="id"]');
    this.sourcePlanInput = null;

    this.handleMainVariantChange = this.handleMainVariantChange.bind(this);
    this.handleSourcePlanChange = this.handleSourcePlanChange.bind(this);
    this.handlePlanSelectEvent = this.handlePlanSelectEvent.bind(this);
    this.handlePotentialPlanClick = this.handlePotentialPlanClick.bind(this);

    this.bind();
    this.refresh();
  }

  PlanCtaWidget.prototype.resolveSourcePlanInput = function() {
    if (this.sourcePlanInput && document.contains(this.sourcePlanInput)) return this.sourcePlanInput;

    var scope = this.scopeNode || document;
    var source = scope.querySelector('[data-plan-select-input]');

    if (!source && this.sectionId) {
      source = document.querySelector('[data-plan-select-widget][data-section-id="' + this.sectionId + '"] [data-plan-select-input]');
    }

    if (!source && this.sectionId) {
      source = document.querySelector('input[name="selling_plan"][form="product-form-' + this.sectionId + '"]');
    }

    this.sourcePlanInput = source || null;
    return this.sourcePlanInput;
  };

  PlanCtaWidget.prototype.bind = function() {
    if (this.mainVariantInput) {
      this.mainVariantInput.addEventListener('change', this.handleMainVariantChange);
    }

    var sourcePlanInput = this.resolveSourcePlanInput();
    if (sourcePlanInput) {
      sourcePlanInput.addEventListener('input', this.handleSourcePlanChange);
      sourcePlanInput.addEventListener('change', this.handleSourcePlanChange);
    }

    document.addEventListener('plan-select:change', this.handlePlanSelectEvent);
    document.addEventListener('click', this.handlePotentialPlanClick);
  };

  PlanCtaWidget.prototype.handleMainVariantChange = function(event) {
    if (!event || !event.target) return;
    this.selectedVariantId = String(event.target.value || this.selectedVariantId || '');
    this.refresh();
  };

  PlanCtaWidget.prototype.handleSourcePlanChange = function() {
    this.refresh();
  };

  PlanCtaWidget.prototype.handlePlanSelectEvent = function(event) {
    if (!event || !event.detail) return;
    var sectionId = String(event.detail.sectionId || '');
    if (sectionId && sectionId !== this.sectionId) return;

    if (event.detail.variantId) {
      this.selectedVariantId = String(event.detail.variantId);
    }

    this.refresh();
  };

  PlanCtaWidget.prototype.handlePotentialPlanClick = function(event) {
    if (!event || !event.target) return;
    var option = event.target.closest('[data-plan-option]');
    if (!option) return;

    var widget = option.closest('[data-plan-select-widget]');
    if (!widget) return;
    if (String(widget.getAttribute('data-section-id') || '') !== this.sectionId) return;

    var self = this;
    window.setTimeout(function() {
      self.refresh();
    }, 0);
  };

  PlanCtaWidget.prototype.getActiveVariant = function() {
    var variantId = this.selectedVariantId;
    if (this.mainVariantInput && this.mainVariantInput.value) {
      variantId = this.mainVariantInput.value;
    }

    return getVariantById(this.product, variantId);
  };

  PlanCtaWidget.prototype.getActivePlanId = function() {
    var sourcePlanInput = this.resolveSourcePlanInput();
    if (!sourcePlanInput) return '';

    var raw = sourcePlanInput.value;
    if (!raw) return '';
    return String(raw);
  };

  PlanCtaWidget.prototype.setButtonState = function(disabled, label) {
    if (!this.buttonNode) return;

    this.buttonNode.disabled = !!disabled;
    if (this.buttonLabelNode && typeof label === 'string') {
      this.buttonLabelNode.textContent = label;
    }
  };

  PlanCtaWidget.prototype.setCompare = function(show, text) {
    if (!this.compareNode) return;
    if (!show) {
      this.compareNode.hidden = true;
      this.compareNode.textContent = '';
      return;
    }

    this.compareNode.hidden = false;
    this.compareNode.textContent = text;
  };

  PlanCtaWidget.prototype.setSave = function(show, text) {
    if (!this.saveNode) return;
    if (!show) {
      this.saveNode.hidden = true;
      this.saveNode.textContent = '';
      return;
    }

    this.saveNode.hidden = false;
    this.saveNode.textContent = text;
  };

  PlanCtaWidget.prototype.refresh = function() {
    if (!this.product) return;

    var variant = this.getActiveVariant();
    if (!variant) return;

    var planId = this.getActivePlanId();
    var allocation = getSellingPlanAllocation(variant, planId);
    var effectivePlanId = allocation ? String(planId) : '';

    var price = Number((allocation && allocation.price) || variant.price || 0);
    var compare = Number((allocation && allocation.compare_at_price) || variant.compare_at_price || price || 0);
    if (compare < price) compare = price;

    var saveAmount = Math.max(0, compare - price);
    var savePercent = compare > 0 ? Math.round((saveAmount / compare) * 100) : 0;

    if (this.variantInput) {
      this.variantInput.value = String(variant.id);
      this.selectedVariantId = String(variant.id);
    }

    if (this.planInput) {
      this.planInput.value = effectivePlanId;
      this.planInput.disabled = !effectivePlanId;
      this.planInput.dispatchEvent(createBubblingEvent('input'));
      this.planInput.dispatchEvent(createBubblingEvent('change'));
    }

    if (this.priceNode) {
      var formatted = formatMoney(price, this.locale, this.currency);
      this.priceNode.textContent = this.priceSuffix ? formatted + ' ' + this.priceSuffix : formatted;
    }

    if (this.currencyNode) {
      this.currencyNode.hidden = !this.showCurrency;
      this.currencyNode.textContent = this.currency;
    }

    var showCompare = this.showCompare && compare > price;
    this.setCompare(showCompare, formatMoney(compare, this.locale, this.currency));

    var saveText = '';
    if (this.showSavings && saveAmount > 0) {
      if (this.savingsMode === 'percent') {
        saveText = this.savePrefix ? this.savePrefix + ' ' + savePercent + '%' : savePercent + '%';
      } else {
        var saveMoney = formatMoney(saveAmount, this.locale, this.currency);
        saveText = this.savePrefix ? this.savePrefix + ' ' + saveMoney : saveMoney;
      }
    }
    this.setSave(!!saveText, saveText);

    if (!variant.available) {
      this.setButtonState(true, this.buttonLabelSoldout);
      return;
    }

    if (this.requirePlan && !effectivePlanId) {
      this.setButtonState(true, this.buttonLabelRequirePlan || this.buttonLabelDefault);
      return;
    }

    this.setButtonState(false, this.buttonLabelDefault);
  };

  PlanCtaWidget.prototype.onVariantChange = function(sectionId, variantId) {
    if (String(sectionId || '') !== this.sectionId) return;
    this.selectedVariantId = String(variantId || this.selectedVariantId || '');
    this.refresh();
  };

  function initWidgets(scope) {
    var nodes = (scope || document).querySelectorAll(WIDGET_SELECTOR);
    nodes.forEach(function(node) {
      if (node.dataset.planCtaReady === 'true') return;
      node.dataset.planCtaReady = 'true';
      widgets.push(new PlanCtaWidget(node));
    });
  }

  function bindVariantSubscription() {
    if (variantSubscription) return;
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS || !PUB_SUB_EVENTS.variantChange) return;

    variantSubscription = subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      if (!event || !event.data) return;
      var sectionId = String(event.data.sectionId || '');
      var variantId = event.data.variant && event.data.variant.id ? String(event.data.variant.id) : '';

      widgets.forEach(function(widget) {
        widget.onVariantChange(sectionId, variantId);
      });
    });
  }

  function start() {
    initWidgets(document);
    bindVariantSubscription();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initWidgets(event.target);
  });
})();
